import React, { useState, useEffect, FC, PropsWithChildren, useRef } from 'react'
import ReactDOM from 'react-dom'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'
import { Props, DEFAULT_STYLES, ANIMATION } from './helpers'
import styles from './FlashMessage.module.scss'

const Animation = (
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<any>, any> => {
  const AnimationComponent = dynamic(
    import(
      /* webpackChunkName: "flashAnimation" */
      'components/Animations/Animation'
    ),
    noSSR
  )
  return (
    <AnimationComponent defaultStyles={DEFAULT_STYLES} duration={250} {...ANIMATION} {...props} />
  )
}

declare let document

const FlashMessagePortal: FC<PropsWithChildren<Props>> = (props) => {
  const { children, closeFlash, isVisible, type } = props
  const [isReady, setupElements] = useState(false)

  const rootRef = useRef<HTMLElement | null>(null)
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const root = document.getElementById('flash')
    if (!root) {
      return
    }

    const container: HTMLDivElement = document.createElement('div')
    container.className = 'flash'
    if (root && !isReady) {
      // Always Cleanup
      root.innerHTML = ''
      root.appendChild(container)
      setupElements(true)
    }

    rootRef.current = root
    containerRef.current = container

    return () => {
      containerRef.current?.remove()
    }
  }, [])

  if (!isReady || containerRef.current === null) {
    return null
  }

  const AnimatedMessage = (
    <Animation isVisible={isVisible}>
      <div className={styles.flashContainer} onClick={closeFlash}>
        {children}
      </div>
    </Animation>
  )

  return ReactDOM.createPortal(AnimatedMessage, containerRef.current)
}

export default FlashMessagePortal
